import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import { CallAPIPromise } from "../billing/common";

const AccountMasterHelp = ({
  onRowClick,
  status,
  onClose,
  onCreatePartyClick,
  refreshList,
  searchText,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    // Change the shadow color
    overflow: "hidden",
    backgroundColor: "white",
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(1);
  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);

  const prefix = useSelector(selectPrefix);

  const windowWidth = useSelector(selectWidth);
  const columns = [
    {
      width:
        windowWidth <= 400
          ? 100
          : windowWidth <= 940
          ? 70
          : windowWidth <= 1156
          ? 120
          : 120,
      headerAlign: "center",
      align: "left",
      field: "MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 100
          : windowWidth <= 940
          ? 130
          : windowWidth <= 1156
          ? 180
          : 240,
      headerAlign: "center",
      align: "left",
      field: "NAME",
      renderHeader: (params) => <div>Party Name</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 80
          : windowWidth <= 1156
          ? 170
          : 220,
      headerAlign: "center",
      align: "left",
      field: "ADDRESS",
      renderHeader: (params) => <div>Address</div>,
    },
    {
      width:
        windowWidth <= 940 ? 100 : windowWidth <= 1156 ? 130 : 150,
      headerAlign: "center",
      align: "left",
      field: "TAX_NUMBER",
      renderHeader: (params) => <div>Tax Number</div>,
    },
    {
      width: windowWidth <= 940 ? 50 : windowWidth <= 1156 ? 60 : 70,
      headerAlign: "center",
      align: "left",
      field: "ACCOUNT_NO",
      renderHeader: (params) => <div>Acc.No.</div>,
    },
  ];
  const mobileColumns = [
    {
      width: 100,
      headerAlign: "center",
      align: "left",
      field: "MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },
    {
      width: 120,
      headerAlign: "center",
      align: "left",
      field: "NAME",
      renderHeader: (params) => <div>Party Name</div>,
    },
    {
      width: 110,
      headerAlign: "center",
      align: "left",
      field: "ADDRESS",
      renderHeader: (params) => <div>Address</div>,
    },
    {
      width: 120,
      headerAlign: "center",
      align: "left",
      field: "TAX_NUMBER",
      renderHeader: (params) => <div>Tax Number</div>,
    },
  ];
  const [searchQuery, setSearchQuery] = useState(searchText ? searchText : "");
  const [fullList, setFullList] = useState([]);
  useEffect(() => {
    if (status) {
      if (searchQuery) {
        const regex = /\d+/;
        const searchT = searchQuery;
        if (searchT) {
          if (regex.test(searchT.substring(0, 1))) {
            getData("", "", true, searchT);
          } else {
            getData(currentPage, searchT, true);
          }
        } else {
          getData("", "");
        }
      } else {
        getData("", "");
      }
    }
  }, [searchQuery, refreshList]);

  useEffect(() => {
    if (searchText) {
      setSearchQuery(searchText ? searchText : "");
    } else {
      if (status) {
        getData("", "");
      }else{
        setSearchQuery("")
      }
    }
  }, [searchText, status]);
  const dispatch = useDispatch();

  const getData = async (page, name, hideLoading, mobile) => {
    if (!hideLoading) {
      dispatch(setSpinnerLoading("Loading"));
    }
    const data = {
      table_prefix: prefix,
      SECTION_NAME: "",
      mobile: mobile ? mobile : "",
      name: name ? name : "",
      page: mobile || name ? 1 : page ? page : currentPage,
      limit: 100,
    };
    CallAPIPromise("/api/accountMaster/listAccountMaster", data, token)
      .then((p) => {
        if (!p.data.error) {
          let list = [];
          const data = p.data.response.data;
          settotalPages(p.data.response.pagination.totalPages);

          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            onClose();
            setRows([]);
            setSearchQuery("");
          }}
          title={"Account Master | Help"}
          columns={windowWidth < 500 ? mobileColumns : columns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onRowClick={(p) => {
            onRowClick(p);
            setRows([]);
          }}
          totalPages={totalPages}
          onChangePagination={(page) => {
            getData(page);
            setCurrentPage(page);
          }}
          currentPage={currentPage}
          hideFooter={true}
          CreateNew={onCreatePartyClick ? onCreatePartyClick : false}
        />
      </div>
    </>
  );
};

export default AccountMasterHelp;
